<template lang="pug">
  div.lottie.animation
</template>

<script>
  import lottie from 'lottie-web';

  /**
   * A component for After Effects based animations using Lottie.
   *
   * Animations are devided into "segments". The first segment should be played when the element
   * containing the animation (e.g. slider) moves into view.
   *
   */
  export default {
    name: 'MqAnimation',
    status: 'under-review',
    version: '1.0.0',

    props: {
      /**
       * The animation data
       */
      animationData: {
        required: false,
        type: Object
      },
      /**
       * The segments of the animation
       */
      segments: {
        required: true,
        type: Array
      }
    },

    computed: {
      animationSteps () {
        return this.segments.filter(seg => seg.from === undefined && seg.to === undefined).length
      },
      _atBeginning () {
        return this.currentSegment < 1
      },
      _finished () {
        return this.currentSegment === this.animationSteps - 1
      }
    },

    data () {
      return {
        currentSegment: -1
      }
    },

    mounted () {
      this._initAnimation()
      this.fixBigCarImageCropping()
    },

    methods: {
      _initAnimation () {
        this.animation = lottie.loadAnimation({
          container: this.$el,
          renderer: 'svg',
          loop: false,
          autoplay: false,
          animationData: this.animationData
        })
      },
      
      fixBigCarImageCropping () {
        setTimeout(() => {
          const lottieCarImage = this.$el.querySelector('image')
          lottieCarImage.setAttribute("preserveAspectRatio", "xMidYMid meet")
        }, 200)
      },
  
      playNextSegment () {
        if (this._finished) return

        this.currentSegment++
        this.animation.playSegments(this.segments[this.currentSegment].frames, true)
      },

      playPreviousSegment () {
        if (this._atBeginning) return

        this.animation.playSegments(this.segments[this.currentSegment].frames.slice().reverse(), true)
        if (!this._atBeginning) this.currentSegment--
      },

      playSegment (segment) {
        if (segment < 0 || segment > this.segments.length - 1) return

        if (Math.abs(segment - this.currentSegment) === 1) {
          if (segment > this.currentSegment) this.playNextSegment()
          if (segment < this.currentSegment) this.playPreviousSegment()
          return
        }

        this._skipToSegment(segment)
        this.currentSegment = segment
      },

      _skipToSegment (segment) {
        if (segment > this.currentSegment) {
          const targetSegment = this.segments.filter(seg => seg.from === this.currentSegment + 1 && seg.to === segment + 1)[0]
          this.animation.playSegments(targetSegment.frames, true)
        }

        if (segment < this.currentSegment) {
          const targetSegment = this.segments.filter(seg => seg.from === segment + 1 && seg.to === this.currentSegment + 1)[0]
          this.animation.playSegments(targetSegment.frames.slice().reverse(), true)
        }
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/MqAnimation.vue